import React from 'react';
import moment from 'moment';
import ListarDatos from '../../../../general/ListarDatos';
import { COLORES_ESTADO } from '../../../helper';

const DEFAULT_AVATAR = { backgroundColor: '#B8B8B8', color: '#D9D7D7' };
const AVATAR_ASIGNACION = { backgroundColor: '#5c6bc0', color: '#FFF' };

/**
 * Historial de estados. Las asignaciones de profesional se guardan como Estado
 * pero no mueven el proceso: se rotulan aparte para no leerse como un estado
 * repetido, y al estudiante no se le muestran.
 */
function DetalleEstadosTab({ estados, esVistaEstudiante = false }) {
    const datos = esVistaEstudiante
        ? (estados || []).filter((e) => !e.es_asignacion_profesional)
        : estados;

    return (
        <ListarDatos
            datos={datos}
            id='tbl_estados_bienestar'
            avatar={({ tipo_estado, es_asignacion_profesional }) => (
                es_asignacion_profesional ? 'P' : tipo_estado.nombre.charAt(0).toUpperCase()
            )}
            color_avatar={({ tipo_estado, es_asignacion_profesional }) => (
                es_asignacion_profesional
                    ? AVATAR_ASIGNACION
                    : (COLORES_ESTADO[tipo_estado.codigo] || DEFAULT_AVATAR)
            )}
            fila_principal={({ tipo_estado, es_asignacion_profesional }) => (
                es_asignacion_profesional ? 'ASIGNACIÓN DE PROFESIONAL' : tipo_estado.nombre.toUpperCase()
            )}
            filas={[
                { id: 'usuario_registro', mostrar: ({ usuario_registro: { primer_nombre, primer_apellido, segundo_apellido } }) => `${primer_nombre} ${primer_apellido} ${segundo_apellido}` },
                { id: 'mensaje', mostrar: ({ mensaje }) => mensaje ? mensaje : '' },
                { id: 'fecha_registro', mostrar: ({ fecha_registro }) => moment(fecha_registro).format('YYYY-MM-DD, h:mm a'), nombre: 'Fecha Registro : ' },
            ]}
        />
    );
}

export default React.memo(DetalleEstadosTab);
